export default __webpack_public_path__ + "static/media/1.4a8b1944.png";